export const INFO_ACTION_TYPES = {
  SET_INFO: "info/SET_INFO",
  FETCH_INFO: "info/FETCH_INFO",
  UPDATE_INFO: "info/UPDATE_INFO",
  SET_PLANS: "info/SET_PLANS",
  UPDATE_PLANS: "info/UPDATE_PLANS",
  SET_ACCOUNTS: "info/SET_ACCOUNTS",
  UPDATE_ACCOUNTS: "info/UPDATE_ACCOUNTS",
};
